import get from 'lodash/get';
/**
 * Constants
 */
import * as TYPES from '../../constants/actionTypes';
import * as APIS from '../../constants/apiEndpoints';

export const login =
  (credentials) =>
  (dispatch, getState, { api }) => {
    return api
      .post(APIS.LOGIN, credentials)
      .then((result) => {
        if(result?.user?.roles?.length > 1){
          return {...result, password: credentials.password};
        }else{
        api.defaults.headers.common.authorization = `Bearer ${get(
          result,
          'access_token',
        )}`;

        dispatch({
          type: TYPES.LOGIN,
          data: {...result, password: credentials.password},
        });
        return result;
      }
      })
      .catch((error) => {
        throw error;
      });
  };

  export const loginMoreRoles =
  (credentials, roles) =>
  (dispatch, getState, { api }) => {
    return api
      .post(APIS.LOGIN, credentials)
      .then((result) => {
        if(result?.user?.roles?.length > 1){
          // Preserve all roles and just set the selected role as current
          const allRoles = result?.user?.roles || [];
          result.user = {
            ...result?.user,
            roles: allRoles,  // Keep all roles
            currentRole: roles // Store selected role separately
          }
          
          api.defaults.headers.common.authorization = `Bearer ${get(
            result,
            'access_token',
          )}`;

          dispatch({
            type: TYPES.LOGIN,
            data: {...result, password: credentials.password}, // Preserve password
          });
          return result;
        }
      })
      .catch((error) => {
        throw error;
      });
  };

export const switchHospital =
  (hospital) =>
  (dispatch, getState, { api }) => {
    return api.post(APIS.SWITCH, hospital).then((result) => {
      api.defaults.headers.common.authorization = `Bearer ${get(
        result,
        'access_token',
      )}`;

      dispatch({
        type: TYPES.SWITCH,
        data: result,
      });
    });
  };

export const logout =
  () =>
  (dispatch, getState, { api }) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TYPES.LOGOUT,
      });
      resolve();
      api.defaults.headers.common = {};
    });
  };
